import { PRODUCTS_PRODUCT_FILTER_EVENTS } from './global-events';

export const productsProductFilterOptions = [
  {
    id: 'all',
    name: 'Всі',
    event: PRODUCTS_PRODUCT_FILTER_EVENTS.PRODUCTS_PRODUCT_FILTER_ALL,
    options: {
      type: 'checkbox',
      activeFilter: false,
    }
  },
  {
    id: 'osago',
    name: 'ОСЦПВ',
    event: PRODUCTS_PRODUCT_FILTER_EVENTS.PRODUCTS_PRODUCT_FILTER_OSAGO,
    options: {
      type: 'checkbox',
    },
  },
  {
    id: 'green_card',
    name: 'ЗК',
    event: PRODUCTS_PRODUCT_FILTER_EVENTS.PRODUCTS_PRODUCT_FILTER_GREEN_CARD,
    options: {
      type: 'checkbox',
    },
  },
  {
    id: 'tourism',
    name: 'ТУРИЗМ',
    event: PRODUCTS_PRODUCT_FILTER_EVENTS.PRODUCTS_PRODUCT_FILTER_TOURISM,
    options: {
      type: 'checkbox',
    },
  },
  {
    id: 'home',
    name: 'ЖИТЛО',
    event: PRODUCTS_PRODUCT_FILTER_EVENTS.PRODUCTS_PRODUCT_FILTER_HOME,
    options: {
      type: 'checkbox',
    },
  },
  {
    id: 'manual',
    name: 'ЗОВНІШНІ ЗАМОВЛЕННЯ',
    event: PRODUCTS_PRODUCT_FILTER_EVENTS.PRODUCTS_PRODUCT_FILTER_EXTERNAL,
    options: {
      type: 'checkbox',
    },
  },
  {
    id: 'miniKasko',
    name: 'МІНІКАСКО',
    event: PRODUCTS_PRODUCT_FILTER_EVENTS.PRODUCTS_PRODUCT_FILTER_MINI_KASKO,
    options: {
      type: 'checkbox',
    },
  },
  {
    id: 'pets',
    name: 'СТРАХУВАННЯ ТВАРИН',
    event: PRODUCTS_PRODUCT_FILTER_EVENTS.PRODUCTS_PRODUCT_FILTER_PETS,
    options: {
      type: 'checkbox',
    },
  }
];
